export const removePlusSign = (value?: string | null): string => {
  if (value === undefined || value === null) {
    return '';
  }
  return value.replace(/\+/g, '');
};
